import {
  BILLING_VAT_RATE_OPTIONS,
  type BillingVatRate,
} from "@shared/billing/invoice-vat";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type BillingVatRateSelectProps = {
  id: string;
  value: BillingVatRate;
  onValueChange: (value: string) => void;
};

/** IVA selector whose long “manual / varios tipos” label stays fully visible. */
export function BillingVatRateSelect({
  id,
  value,
  onValueChange,
}: BillingVatRateSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        id={id}
        className="data-[size=default]:!h-auto data-[size=sm]:!h-auto min-h-11 w-full min-w-0 max-w-full items-start whitespace-normal text-left"
      >
        <SelectValue className="!line-clamp-none min-w-0 flex-1 overflow-visible whitespace-normal [overflow-wrap:anywhere]" />
      </SelectTrigger>
      <SelectContent className="max-w-[calc(100vw-2rem)]">
        {BILLING_VAT_RATE_OPTIONS.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            className="whitespace-normal [overflow-wrap:anywhere]"
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
